import type {
	EChartsDataPoint,
	ViewTagDataSet,
} from "../models/TrendingModelsV2";

/**
 * Transforms API data to ECharts format
 */
export const formatDataForECharts = (
	seriesData: ViewTagDataSet[],
): EChartsDataPoint[] => {
	return seriesData.map((point) => ({
		timestamp:
			typeof point.timestamp === "string"
				? new Date(point.timestamp).getTime()
				: point.timestamp,
		value: point.value,
	}));
};

/**
 * Converts ECharts data format to [timestamp, value] array format
 */
export const toEChartsArrayFormat = (
	data: EChartsDataPoint[],
): [number, number | null][] => {
	return data.map((point) => [point.timestamp, point.value]);
};
